import { useEffect } from "react";
import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import ViewMoreDetailsLink from "../reusable-components/ViewMoreDetailsLink"; // Adjust the import as needed
import AOS from "aos";
import "aos/dist/aos.css";

const faq_array = [
  {
    question:
      "Why choose Bytesberry Technologies as a Software Development Service Provider?",
    answer:
      "We are a well reputed software and mobile app development company in Sikkim having a cumulative experience of 25+ years in this field...",
    detailsLink: 1,
    detailsUrl: "/#whyBB",
  },
  {
    question: "What Software Development Services do you offer?",
    answer:
      "We provide all-inclusive software related services, such as custom software development, web and mobile app creation...",
    detailsLink: 1,
    detailsUrl: "/our-services",
  },
  {
    question: "What Technology do you use to develop applications?",
    answer:
      "We provide a wide range of software and web development services that cover a number of technologies...",
    detailsLink: 0,
  },
  {
    question: "What is the Cost/Time involved to develop a software?",
    answer:
      "This is determined by the nature & the complexity of the project. These factors typically include:",
    detailsLink: 0,
    bullet_points: [
      `Type of the project whether it is a simple website, dynamic website, web portal or a mobile app...`,
      `The nature and the volume of the transactions in the solution.`,
      `The targeted platforms (Browser, Tablets, mobile platforms such as Android and IOS).`,
      `Design complexities.`,
      `Nature and access roles of users/stakeholders.`,
      `Complexities within the business rules that determines the underlined users and their access roles.`,
    ],
  },
  {
    question: "How would you ensure Security of the Software?",
    answer:
      "While building software applications, we implement various security measures such as adopting secure coding practices...",
    detailsLink: 0,
  },
  {
    question: "What Software Development Life Cycle do you adhere to?",
    answer:
      "We often use the Agile software development life cycle, which is an incremental and iterative method...",
    detailsLink: 0,
  },
  {
    question: "What Soft-Skills Training do you provide?",
    answer:
      "A person's soft skills, as opposed to their technical ones, are a collection of aptitudes relating to people...",
    detailsLink: 0,
    bullet_points: [
      `Communication`,
      `Time Management`,
      `Work Ethics`,
      `Teamwork`,
      `Leadership`,
      `Cooperation & Coordination`,
      `Interpersonal Skills`,
      `People management`,
    ],
  },
];

export default function FaqNew() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: "ease-in-out",
    });
  }, []);

  return (
    <div className="min-h-screen w-full px-4 sm:px-6 lg:px-8 pt-24 sm:pt-28 bg-gray-50 font-poppins">
      <div className="mx-auto w-full max-w-screen-lg divide-y divide-gray-200 rounded-xl bg-white p-4 sm:p-6 lg:p-10 shadow-lg">
        <header class="text-2xl sm:text-3xl md:text-4xl lg:text-3xl font-bold text-center mb-14 text-gray-800 my-8 ">
          Frequently Asked Questions
        </header>

        {faq_array.map((item, index) => (
          <div key={index} data-aos="fade-up" className="py-4 sm:py-5">
            <Disclosure as="div">
              {({ open }) => (
                <>
                  <Disclosure.Button className="group flex w-full items-center justify-between text-left">
                    <span className="text-sm sm:text-base md:text-lg font-medium text-gray-800 group-hover:text-gray-600">
                      {item.question}
                    </span>
                    <ChevronDownIcon
                      className={`h-5 w-5 sm:h-6 sm:w-6 text-gray-500 transition-transform duration-200 ${
                        open ? "rotate-180" : ""
                      }`}
                    />
                  </Disclosure.Button>

                  <Disclosure.Panel
                    static
                    className={`overflow-hidden transition-all duration-500 ease-in-out ${
                      open ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
                    } mt-2 text-xs sm:text-sm md:text-base text-gray-600`}
                  >
                    <div className="py-2 sm:py-3">
                      <p>{item.answer}</p>

                      {item.bullet_points && (
                        <ul className="mt-3 list-disc list-inside text-gray-700">
                          {item.bullet_points.map((point, idx) => (
                            <li key={idx} className="mb-1">
                              {point}
                            </li>
                          ))}
                        </ul>
                      )}

                      {item.detailsLink === 1 && (
                        <div className="mt-4">
                          <ViewMoreDetailsLink linkUrl={item.detailsUrl} />
                        </div>
                      )}
                    </div>
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          </div>
        ))}
      </div>
    </div>
  );
}
